// extracted by mini-css-extract-plugin
export var emailBlockLink = "_of-0";